import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrl;

@Injectable()
export class WidgetNotificacionService {

  constructor(private http: HttpClient) {
  }

  notify(model) {
    return this.http.post(`${API_URL}/api/asistencia/notificar/tarea`, model)
      .pipe(
        map(res => res)
      );
  }
}
